import {
  ABTestExperiment,
  ABTestExperimentConfig,
  fetchParticipating,
} from '@jusbrasil-web/shared-ab-test'
import { GetServerSidePropsContext } from 'next'

export const buildExperimentContext = async (
  ctx: Pick<GetServerSidePropsContext, 'query' | 'req' | 'resolvedUrl'>,
  activeExperiments: ABTestExperimentConfig[]
): Promise<ABTestExperiment[]> => {
  const experiments = await fetchParticipating(ctx, activeExperiments, {
    participatingOnly: true,
    simulate: false,
  })

  return experiments
}
